import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { sendEmailResult } from "../../data/Contentapi";
import { getConfig } from "../../loadconfig";
import { MyContext } from "../../globalContext";

const EmailPopup = ({ showPopup, setShowPopup, pageType }) => {
  const config = getConfig();
  const { languageData,  searchCriteria, selectedForDetails, searchFilter } =
    useContext(MyContext);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const { t } = useTranslation();
  const invalidEmail = t(`emailValidate`);
  const isButtonDisabled = !email || !!emailError || false;
  const mycontext = useContext(MyContext);

  const handleClosePopup = () => {
    setShowPopup(false);
    setEmail("");
    setEmailError("");
  };

  const validateEmail = (value) => {
    if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return invalidEmail;
    } else {
      return "";
    }
  };

  const handleEmailChange = (event) => {
    const value = event.target.value.trim();
    setEmail(value);
    setEmailError("");
  };

  const sendEmail = async () => {
    const error = validateEmail(email);
    if (error) {
      setEmailError(invalidEmail);
      return;
    }
    if (!emailError && email) {
      handleClosePopup();
    }

    try {
      let apiEndPoint = config.PROVIDER_SEARCH_EMAIL_RESULT_URL;
      let payLoadData = { ...searchCriteria };
      if(searchFilter && Object.keys(searchFilter).length > 0) {
        payLoadData = {...payLoadData, ...searchFilter}
    }
      if (pageType === "detail") {
        apiEndPoint = config.PROVIDER_DETAILS_EMAIL_RESULT_URL;
        payLoadData = { ...selectedForDetails, language: languageData };
      }
      payLoadData["emailAddress"] = email;
      await sendEmailResult(apiEndPoint, payLoadData, mycontext);
      setShowPopup(false);
    } catch (e) {
      console.error("Error sending the Email:", e);
    }
  };

  return (
    <Dialog
      open={showPopup}
      onClose={handleClosePopup}
      aria-labelledby="email-results-dialog"
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{ fontWeight: "bold", position: "relative" }}
        id="email-results-dialog"
      >
        {t(`emailresults`)}
        <IconButton
          edge="end"
          color="inherit"
          aria-label="close"
          onClick={handleClosePopup}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "16px",
          overflow: "hidden",
        }}
      >
        <Box width="100%">
          <label htmlFor="email" className="textField-label">
            {t(`email`)}
          </label>
          <Box display="flex" alignItems="center" width="100%">
            <Box sx={{ flex: 7, marginRight: 1 }}>
              <TextField
                autoFocus
                margin="dense"
                id="email"
                type="email"
                fullWidth
                variant="outlined"
                value={email}
                onChange={handleEmailChange}
                error={!!emailError}
                helperText={emailError}
                data-testid="emailInput"
              />
            </Box>
            <Button
              variant="contained"
              color="primary"
              data-testid="sendEmailButton"
              onClick={sendEmail}
              disabled={isButtonDisabled}
            >
              {t(`sendEmail`)}
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

EmailPopup.propTypes = {
  showPopup: PropTypes.boolean,
  setShowPopup: PropTypes.boolean,
  pageType: PropTypes.string,
};

export default EmailPopup;
